/**
 * Core GraphQL — games played inside a chat (`/api/core/graphql/`). A game is one message whose
 * board every move updates.
 */

const QUIZ_USER = "userId username fullName profile { avatarUrl }";
const QUIZ_PICK = `userId user { ${QUIZ_USER} } choice isCorrect points`;

/**
 * A quiz as the viewer may see it (null for the board games): its settings, the viewer's open
 * question (never its answer), the viewer's answered questions and the standings.
 */
const QUIZ_FIELDS = `
  category { slug nameAr nameEn emoji isMixed }
  difficulty language questionCount secondsPerQuestion isGroup
  started canJoin canReview deadline nextIndex
  current { index text code choices categorySlug servedAt deadlineAt remainingMs }
  myAnswers {
    index questionId text code choices categorySlug choice timedOut isCorrect correctIndex explanation points answerMs
    picks { ${QUIZ_PICK} }
  }
  players { rank userId user { ${QUIZ_USER} } points correctCount answeredCount finished fastestMs }
`;

/** Everything a game card shows. */
export const CHAT_GAME_FIELDS = `
  id kind status turn state winnerId winLine lastMove movesCount mySeat score messageId
  invitedId clockMs clockMinutes drawOfferedBy
  players { userId username fullName profile { avatarUrl } }
  watchers { userId username fullName }
  quiz { ${QUIZ_FIELDS} }
`;

/** What the chat lists need for "🎮 Your turn in XO" or "🎮 Sara challenges you to Chess". */
export const CHAT_GAME_PREVIEW_FIELDS = "kind status turn mySeat winnerId invitedId players { userId fullName }";

export const CORE_QUERY_CHAT_GAME = `
  query ChatGame($gameId: Int!) {
    chatGame(gameId: $gameId) { ${CHAT_GAME_FIELDS} }
  }
`;

/** The quiz's subjects ("mixed" first) with how many questions each has per language and difficulty. */
export const CORE_QUERY_QUIZ_CATEGORIES = `
  query QuizCategories {
    quizCategories { slug nameAr nameEn emoji isMixed counts { language difficulty count } }
  }
`;

/** Every question of a quiz with its answer and everyone's choices; null until the viewer may see it. */
export const CORE_QUERY_QUIZ_REVIEW = `
  query QuizReview($gameId: Int!) {
    quizReview(gameId: $gameId) {
      index questionId text code choices categorySlug correctIndex explanation answered myChoice myPoints isCorrect
      picks { ${QUIZ_PICK} }
    }
  }
`;
